import { Link } from "react-router-dom";
import { useLoc } from "@/lib/loc";
import { useTranslation } from "react-i18next";
import { Play } from "lucide-react";

export default function VideoCard({ video, className = "" }) {
  const loc = useLoc();
  const { t } = useTranslation();
  return (
    <Link
      to={`/video/${video.slug || video.id}`}
      data-testid={`video-card-${video.id}`}
      className={`group relative block ${className || "w-[260px] shrink-0"}`}
    >
      <div className="relative aspect-video overflow-hidden rounded-lg bg-[hsl(var(--surface-elevated))] ring-1 ring-white/5 transition-transform duration-300 ease-out group-hover:scale-[1.05] group-hover:ring-white/15 group-hover:shadow-2xl group-hover:shadow-black/60">
        <img
          src={video.thumbnail_url || "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='9'><rect width='16' height='9' fill='%23191920'/></svg>"}
          alt={loc(video.title)}
          loading="lazy"
          onError={(e) => { e.currentTarget.style.opacity = 0.3; }}
          className="h-full w-full object-cover opacity-90 transition-opacity duration-300 group-hover:opacity-100"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
        {video.is_sponsored && (
          <span className="absolute left-2 top-2 rounded-sm border border-white/10 bg-black/60 px-2 py-1 text-[10px] uppercase tracking-widest text-white/80 backdrop-blur-md">
            {t("common.sponsored")}
          </span>
        )}
        <div className="absolute bottom-2 right-2 flex h-9 w-9 items-center justify-center rounded-full bg-primary text-primary-foreground opacity-0 shadow-lg transition-opacity duration-300 group-hover:opacity-100">
          <Play className="h-4 w-4 fill-current" />
        </div>
      </div>
      <h3 className="mt-2 line-clamp-1 font-heading text-sm font-medium text-foreground/90">
        {loc(video.title)}
      </h3>
      <p className="text-xs text-muted-foreground">
        {(video.views || 0).toLocaleString("fr-FR")} {t("common.views")}
      </p>
    </Link>
  );
}
